import { css, type Theme } from '@emotion/react';

export const container = css`
  padding: 0px 20px 20px 20px;
  display: flex;
  flex-direction: column;
  align-items: start;
  gap: 20px;
  width: 100%;
  max-width: 362px;
`;

export const score = (theme: Theme) => css`
  color: ${theme.colors.gray[500]};
`;

export const banner = (theme: Theme) => css`
  background-color: ${theme.colors.primary[25]};
  width: 277px;
  height: 100px;
  border-radius: 8px;
  margin: 0 auto 30px auto;
  position: relative;
`;

export const remainingTimeContainer = css`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: baseline;
`;

export const remainingTime = (theme: Theme) => css`
  color: ${theme.hues.blue[700]};
`;

export const achievementContainer = css`
  align-self: center;
  position: absolute;
  top: 50px;
  left: 50%;
  transform: translate(-50%, -50%);
`;

export const title = css`
  margin-bottom: 10px;
  word-break: break-word;
`;

export const label = css`
  margin-bottom: 40px;
  display: block;
`;

export const action = (theme: Theme, isCompleted: boolean) => css`
  background-color: ${isCompleted ? theme.colors.success[25] : theme.colors.gray[25]};
  padding: 10px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const actionsContainer = css`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;
